import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createCurriculum, createMeal, deleteCurriculum, fetchCurriculumCategory, fetchCurriculumPlan, updateCurriculum, updateStatusCurriculum } from "../../../service/api";





export const getCurriculumPlan = createAsyncThunk(
    "curriculum/getcurriculum",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchCurriculumPlan(params)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getCurriculumCategory = createAsyncThunk(
    "curriculum/getcategory",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchCurriculumCategory(params)
            console.log("curriculum category", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const deleteCurriculums = createAsyncThunk(
    "curriculum/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteCurriculum(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addCurriculum = createAsyncThunk(
    "curriculum/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createCurriculum(formValue)
            if (response.status === 201) {
                console.log("meals", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editCurriculum = createAsyncThunk(
    "curriculum/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateCurriculum(formValue)
            if (response.status === 201) {
                console.log("curriculum", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editCurriculumStatus = createAsyncThunk(
    "curriculum/editStatus",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateStatusCurriculum(formValue)
            if (response.status === 201) {
                console.log("curriculum", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const curriculumSlice = createSlice({
    name: "curriculum",
    initialState: {
        curriculumList: [],
        curriculumCategory: [],
        defaultRoomId: null,
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        dates: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setDateFilter: (state, action) => {
            state.dates = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            //curriculum plan
            .addCase(getCurriculumPlan.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getCurriculumPlan.fulfilled, (state, action) => {
                state.isLoading = false;
                state.curriculumList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })

            .addCase(getCurriculumPlan.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //category
            .addCase(getCurriculumCategory.pending, (state) => {
                state.error = null
            })

            .addCase(getCurriculumCategory.fulfilled, (state, action) => {
                state.curriculumCategory = action.payload.data;
            })

            .addCase(getCurriculumCategory.rejected, (state, action) => {
                state.error = action.payload
            })

            // POST
            .addCase(addCurriculum.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addCurriculum.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addCurriculum.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // delete
            .addCase(deleteCurriculums.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteCurriculums.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteCurriculums.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editCurriculum.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editCurriculum.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editCurriculum.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            //status change
            .addCase(editCurriculumStatus.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editCurriculumStatus.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editCurriculumStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams, setPagination, setDateFilter } = curriculumSlice.actions;

export default curriculumSlice.reducer;
